import { QueryResponseProvider } from "../check-user-funds/user-funds-list/core/QueryResponseProvider";
import HomePage from "./HomePage";

const HomePageWrapper = () => {
  return (
    <QueryResponseProvider>
      <HomePage />
    </QueryResponseProvider>
  );
};

export default HomePageWrapper;
